/**
 * 呼び出し元画面に返却する情報を格納するVO
 */
export class KYMW1107OutputModel {
  /** Ｐコード */
  public pCode: string = <string>'';

  /** アイテムコード */
  public itemCode: string = <string>'';

  /** 分析連番 */
  public analysisSeqNo: string = <string>'';

  /** 分析単位 */
  public analysisUnit: string = <string>'';

  /** 栄養成分備考 */
  public nutrientNote: string = <string>'';

  /** 栄養成分リスト */
  public nutrientComponentList: Array<any> = null;
}
